import { createAsyncThunk } from '@reduxjs/toolkit';
import RootState from "../states/root.state";
import { getSpaUpdateProgress } from '../../services/api/spaUpdateProgress.api';

export interface FetchSpaUpdateProgressArg {
  params: string;
  /** Auto-refresh ticks pass silent:true so the table never flashes its spinner. */
  silent?: boolean;
}

export const fetchSpaUpdateProgress = createAsyncThunk<any, FetchSpaUpdateProgressArg, { rejectValue: string; state: RootState }>(
  'spaUpdateProgress/list',
  async ({ params }, { rejectWithValue, getState }) => {
    try {
      const { user } = getState();
      const response = await getSpaUpdateProgress(user.accessToken, params);
      return { ...response.data, lastFetched: Date.now() };
    } catch (error: any) {
      if (error.response) {
        return rejectWithValue(error.response.data.data?.message ?? error.response.data.message ?? "An error occurred while fetching migration progress.");
      }
      return rejectWithValue('An error occurred while fetching migration progress.');
    }
  }
);
